module.exports = __webpack_public_path__ + "static/media/print-light.a6d8c151.svg";